"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactOutsideClickHandler = _interopRequireDefault(require("react-outside-click-handler"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _OptionList = _interopRequireDefault(require("../SelectInput/Select/OptionList"));

var _utils = require("../../utils");

var _uid = _interopRequireDefault(require("../../utils/uid"));

require("./AutoComplete.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function AutoComplete(props) {
  var id = props.id,
      valueProp = props.value,
      dataSource = props.dataSource,
      placeholder = props.placeholder,
      children = props.children,
      classNameProp = props.className,
      dropdownClassNameProp = props.dropdownClassName,
      onSearch = props.onSearch,
      onSelect = props.onSelect;
  var listRef = (0, _react.useRef)(null);
  var uId = (0, _react.useMemo)(function () {
    return id || (0, _uid.default)('results');
  }, [id]);

  var _useState = (0, _react.useState)((0, _utils.transformOptions)(dataSource)),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = (0, _react.useState)(valueProp || ''),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var _useState5 = (0, _react.useState)(-1),
      _useState6 = _slicedToArray(_useState5, 2),
      activeIndex = _useState6[0],
      setActiveIndex = _useState6[1];

  (0, _react.useEffect)(function () {
    setData((0, _utils.transformOptions)(dataSource));
  }, [dataSource]);
  (0, _react.useEffect)(function () {
    setValue(valueProp || '');
  }, [valueProp]);
  (0, _react.useEffect)(function () {
    if (listRef.current) {
      var _listRef$current = listRef.current,
          scrollTop = _listRef$current.scrollTop,
          height = _listRef$current.offsetHeight;
      var scrollBottom = scrollTop + height;
      var item = listRef.current.children[activeIndex];
      var heightItem = item && item.offsetHeight;
      var topItem = item && item.offsetTop;

      if (topItem > scrollBottom - heightItem) {
        listRef.current.scrollTo({
          top: topItem - scrollBottom + scrollTop + heightItem
        });
      }

      if (topItem < scrollTop) {
        listRef.current.scrollTo({
          top: topItem
        });
      }
    }
  }, [activeIndex]);

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      opened = _useState8[0],
      setOpened = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = _slicedToArray(_useState9, 2),
      options = _useState10[0],
      setOptions = _useState10[1];

  var closeDropdown = function closeDropdown() {
    setOpened(false);
    setActiveIndex(-1);
  };

  var updateOptions = function updateOptions() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : value;
    var filtered = data.filter(function (item) {
      return item.value.toLocaleLowerCase().includes(val.toLocaleLowerCase());
    });
    setOptions(filtered);
  };

  var onChange = function onChange(e) {
    setValue(e.target.value);
    onSearch(e.target.value);
    setOpened(true);
    setActiveIndex(0);
    updateOptions(e.target.value);
  };

  var onFocus = function onFocus() {
    setOpened(true);
    setActiveIndex(0);
    updateOptions();
  };

  var selectItem = function selectItem(value) {
    var selected = typeof value === 'string' ? value : value && value.value;
    setValue(valueProp !== undefined ? valueProp : selected);
    onSelect(selected);
    closeDropdown();
  };

  var onKeyUp = function onKeyUp(e) {
    switch (e.key) {
      case 'ArrowUp':
      case 'ArrowDown':
      case 'Escape':
      case 'Enter':
        e.preventDefault();
        return;

      default:
        updateOptions();
    }
  };

  var onKeyDown = function onKeyDown(e) {
    if (e.key === 'Escape') {
      closeDropdown();
      setValue('');
      return;
    }

    if (options.length < 1) return;

    switch (e.key) {
      case 'ArrowUp':
        if (activeIndex > 0) {
          setActiveIndex(activeIndex - 1);
        }

        break;

      case 'ArrowDown':
        if (activeIndex < options.length - 1) {
          setActiveIndex(activeIndex + 1);
        }

        break;

      case 'Enter':
        selectItem(options[activeIndex]);
        return;

      case 'Tab':
        if (activeIndex >= 0) {
          selectItem(options[activeIndex]);
        }

        closeDropdown();
        return;

      default:
        return;
    }

    e.preventDefault();
  };

  var selected = (0, _react.useMemo)(function () {
    return options[activeIndex] && options[activeIndex].value;
  }, [options, activeIndex]);
  var inputProps = (0, _react.useMemo)(function () {
    return {
      value: value,
      placeholder: placeholder,
      role: 'combobox',
      autocomplete: 'off',
      'aria-owns': uId,
      'aria-controls': uId,
      'aria-expanded': opened,
      'aria-describedby': 'initInstr',
      'aria-autocomplete': 'both',
      'aria-activedescendant': selected,
      onFocus: onFocus,
      onKeyUp: onKeyUp,
      onKeyDown: onKeyDown,
      onChange: onChange
    };
  }, [uId, placeholder, value, opened, selected, onChange, onFocus, onKeyUp, onKeyDown]);
  var child = (0, _react.useMemo)(function () {
    return children && /*#__PURE__*/_react.default.cloneElement(children, inputProps);
  }, [children, inputProps]);
  var className = (0, _utils.getClassNames)(classNameProp, 'AutoComplete', {
    AutoComplete__opened: opened && options.length > 0
  });
  var dropdownClassName = (0, _utils.getClassNames)(dropdownClassNameProp, 'AutoComplete-dropdown', {
    'AutoComplete-dropdown__opened': opened && options.length > 0
  });
  return /*#__PURE__*/_react.default.createElement(_reactOutsideClickHandler.default, {
    onOutsideClick: closeDropdown
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, child || /*#__PURE__*/_react.default.createElement(_TextInput.default, inputProps), /*#__PURE__*/_react.default.createElement("div", {
    id: uId,
    className: dropdownClassName,
    role: "listbox",
    ref: listRef
  }, /*#__PURE__*/_react.default.createElement(_OptionList.default, {
    name: "".concat(uId, "-option"),
    options: options,
    selected: selected,
    clicked: selectItem
  }))));
}

AutoComplete.propTypes = {
  /** Id for the component */
  id: _propTypes.default.string,

  /** The default value */
  value: _propTypes.default.string,

  /** list of options to show in dropdown list */
  dataSource: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string
  })])),

  /** Placeholder text */
  placeholder: _propTypes.default.string,

  /** Callback on selected value from the search list function(value) */
  onSelect: _propTypes.default.func,

  /** Callback on change function(value) */
  onSearch: _propTypes.default.func,

  /** Custom class */
  className: _propTypes.default.string,

  /** The dropdown custom class */
  dropdownClassName: _propTypes.default.string,

  /** the custom input component */
  children: _propTypes.default.string
};
AutoComplete.defaultProps = {
  id: null,
  value: undefined,
  dataSource: [],
  placeholder: 'Start typing...',
  onSelect: function onSelect() {},
  onSearch: function onSearch() {},
  className: undefined,
  dropdownClassName: undefined,
  children: null
};
var _default = AutoComplete;
exports.default = _default;